const API_URL = '';  // Use relative URLs

// Get next scheduled analysis time for a specific view and pillar
export const getNextScheduledAnalysis = async (viewId, pillarId) => {
  try {
    const response = await fetch(`${API_URL}/api/analysis/next-scheduled/${pillarId}/${viewId}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching next scheduled analysis:', error);
    return { success: false, data: null };
  }
};

// Check if there's a processing analysis for a specific view and pillar
export const getProcessingAnalysisStatus = async (viewId, pillarId) => {
  try {
    const response = await fetch(`${API_URL}/api/analysis/processing-status/${pillarId}/${viewId}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching processing analysis status:', error);
    return { success: false, data: null };
  }
}; 